import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { PreloaderLayout } from "@jmc/solid-design-system/src/components/organisms/VideoPlayer/PreloaderLayout/PreloaderLayout";
import style from "../style.module.scss";

export const BrightcovePreview = (props: { thumbnail: string }) => {
    const { thumbnail } = props;
    return thumbnail ? (
        <PreloaderLayout dataTestId={`BrightcovePreview`} thumbnail={thumbnail} />
    ) : (
        <>
            <Skeleton style={{ paddingTop: "var(--hd-ratio)" }}></Skeleton>
            <div className={`video-js vjs-big-play-centered vjs-fluid ${style.nonBackgroundPlayer}`}>
                <div className={style.playButton}>
                    <button className={"vjs-big-play-button"} type="button" aria-disabled="false">
                        <span className="vjs-icon-placeholder" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </>
    );
};
